export const categories = [
  {
    title: 'Music',
    id: 134,
    imageURL: 'music.jpg'
  },
  {
    title: 'TV & Movies',
    id: 68,
    imageURL: 'tv.jpg'
  },
  {
    title: 'Comedy',
    id: 133,
    imageURL: 'comedy.jpg'
  },
  {
    title: 'Technology',
    id: 127,
    imageURL: 'technology.jpg'
  },
  {
    title: 'Kids & Family',
    id: 132,
    imageURL: 'kids.jpg'
  },
  {
    title: 'Science',
    id: 107,
    imageURL: 'science.jpg'
  },
  {
    title: 'Health & Living',
    id: 82,
    imageURL: 'health.jpg'
  },
  {
    title: 'Society & Culture',
    id: 122,
    imageURL: 'society.jpg'
  },
  {
    title: 'News & Politics',
    id: 99,
    imageURL: 'news.jpg'
  },
  {
    title: 'Arts',
    id: 100,
    imageURL: 'arts.jpg'
  },
  {
    title: 'Games',
    id: 85,
    imageURL: 'games.jpg'
  },
  {
    title: 'Business',
    id: 93,
    imageURL: 'business.jpg'
  },
  {
    title: 'Sports',
    id: 77,
    imageURL: 'sports.jpg'
  },
  {
    title: 'Religion & Spirituality',
    id: 69,
    imageURL: 'religion.jpg'
  }
];
